import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  DesignerRequestVerb,
  INodeInfo,
  SETTINGS_TAB_PATH,
  getAppSettings,
  getNodeInfo,
} from '@qodly/shared';
import { AppState } from '..';

export const fetchSettings = createAsyncThunk<
  INodeInfo,
  void,
  {
    state: AppState;
    rejectValue: string;
  }
>('settings/fetch', async () => {
  const response = (await getNodeInfo({
    verb: DesignerRequestVerb.GET_INFO,
    path: SETTINGS_TAB_PATH,
    content: true,
    as: 'json',
  })) as INodeInfo;

  return response;
});

export const fetchAppSettings = createAsyncThunk(
  'settings/app',
  getAppSettings,
);
